import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CloseButtonRow = styled.div`
  position: absolute;
  top: ${Spacing.S16};
  right: ${Spacing.S16};
`

export const ModalImageWrapper = styled.div`
  margin: -${Spacing.S12} auto 0;
`

export const CreateDepositInvoiceEntryPointModalSteps = styled.ol`
  padding-left: ${Spacing.S20};
  list-style-type: decimal;
`
